import i18n from "@/i18n";

export const buttonsFields = [
    {
        key: "text",
        label: i18n.t("template.text"),
        sortable: true
    },
    {
        key: "hideText",
        label: i18n.t("template.hideText"),
        sortable: true
    },
    {
        key: "image",
        label: i18n.t("common.image")
    },
    {
        key: "layer",
        label: i18n.t("background.layer"),
        tdClass: "td-sm"
    },
    {
        key: "width",
        label: i18n.t("common.width"),
        tdClass: "td-sm"
    },
    {
        key: "height",
        label: i18n.t("common.height"),
        tdClass: "td-sm"
    },
    {
        key: "x",
        label: i18n.t("background.posX"),
        tdClass: "td-sm"

    },
    {
        key: "y",
        label: i18n.t("background.posY"),
        tdClass: "td-sm"

    },
    {
        key: "eventName",
        label: i18n.t("stage.eventName"),
        tdClass: "td-sm"

    },
    {
        key: "style",
        label: i18n.t("template.style"),
        tdClass: "td-sm"

    },
    {
        key: "actions",
        label: ""
    }];
